import React, { Component } from 'react'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import storage from 'redux-persist/lib/storage'

import SentryHandler from './SentryHandler'
import SentryWrapper from './SentryWrapper'

import reducers from '../../redux/reducers'
import Router from '../../services/Router'
import NotificationPopup from '../../services/NotificationPopup'
import { ToastContainer } from 'react-toastify'

import '../../styles/global.css'
import CookiesNotification from '../CookiesNotification'

/*
  The goal of this transform is remove lastFetch attribute.
  The lastFetch its used to see if will fetch API and that was being a problem,
  because the users were doing some things to force the fetch API
 */
const blacklistTransform = createTransform(
  (inboundState, key) => {
    if (key !== 'userReducer') return inboundState
    else {
      return {
        ...inboundState,
        user: {
          ...inboundState.user,
          lastFetch: undefined,
          lastMoodboardFetch: undefined
        }
      }
    }
  }
)

const persistConfig = {
  key: 'root',
  storage,
  transforms: [blacklistTransform]
}

class App extends Component {
  constructor (props) {
    super(props)

    SentryHandler.init({ dsn: 'https://9557b5efd1504c9d8c69129e470f2715@o533248.ingest.sentry.io/5652644' })
    this.state = {
      store: null,
      persistor: null
    }
  }
  // Initializes redux
  async componentDidMount () {
    // Wrap store initialization on a try/catch, so if will notify errors before render
    // is called with SentryWrapper mounted
    try {
      const store = createStore(persistReducer(persistConfig, reducers))
      const persistor = persistStore(store)
      this.setState({ store, persistor })
    } catch (err) {
      SentryHandler.withScope(scope => {
        scope.setTag('type', 'root')
        console.error(`Error on redux store initialization: ${err}`)
      })

      setTimeout(() => window.location.reload(true), 5000) // Refreshs with forceGet: true
    }
  }

  render () {
    // Do not render until store is loaded
    if (!this.state.store) return null
    const { store, persistor } = this.state

    return (
      <SentryWrapper>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <NotificationPopup />
            <Router />
            <CookiesNotification />
          </PersistGate>
        </Provider>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </SentryWrapper>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/globals/App.js